import CryptoJS from 'crypto-js'
export default {
    makeSign(body, appId, appKey) {
        const sha1text = CryptoJS.SHA1(appKey + body + appKey).toString();
        var md5HEX = CryptoJS.MD5(sha1text + appId).toString();
        return md5HEX
    },
    objectKeySort(arys) {
        let newKey = Object.keys(arys).sort()
        let newObj = ''
        for (let i = 0; i < newKey.length; i++) {
            let value = arys[newKey[i]]
            let key = [newKey[i]]
            let type = typeof value
            if (type == 'number' && value != null) {
                newObj += key + '=' + value + '&'
            } else if (type == 'string' && this.isNotEmpty(value)) {
                newObj += key + '=' + value + '&'
            } else {
                newObj += key + '=' + value + '&'
            }
        }
        return newObj.substring(0, newObj.length - 1)
    },
    getUrlQuery: function(name, Url) {
        var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$|#)', 'i'), url = Url || location.search
        if (reg.test(url)) {
            return decodeURI(RegExp.$2.replace(/\+/g, ' '))
        }
        return ''
    },
    isNotEmpty : function(string) {
        if (string == null) {
            return false
        }
        string = string + ''
        return string != undefined && string != null && string.length > 0 ? true : false;
    },
    isEmpty: function(string) {
        return this.isNotEmpty(string) ? false : true;
    },
    findDictionary: function(array, key){
        if (array == null) {
            return null;
        }
        return array.find(f => f['diValue'] == key)
    },
    findDictionaryName: function(dictionary = [], key) {
        const dictionaryItem = this.findDictionary(dictionary, key)
        if (dictionaryItem == null) {
            return ''
        }
        return dictionaryItem['diName'] || ''
    },
    isIOS: function() {
        var u = navigator.userAgent;
        return u.indexOf('Mac OS') > -1
    },
    isWx: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.match(/MicroMessenger/i) == 'micromessenger' ? true : false
    }
}

